import AppForm from '../app-components/Form/AppForm';

Vue.component('document-type-form', {
    mixins: [AppForm],
    props: {
        'documentGroups': {
            //type: Array,
            required: true
        },
    }, 
    data: function() {
        return {
            form: {
               title: '',
               document_groups: []  
            }
        }
    }, 
   

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-type/Form.js